import { ROUTES } from "../constants"
import Dashboard from "../pages/dashboard"
import ForgotPassword from "../pages/forgotpassword"
import Login from "../pages/login"
import ManageAdminComponent from "../pages/manage-admin"
import CreateAdmin from "../pages/manage-admin/createAdmin/CreateAdmin"
import ManageDepartments from "../pages/manageDepartments"
import CreateDepartment from "../pages/manageDepartments/create"
import ManageEmployee from "../pages/manageEmployee"
import CreateEmployee from "../pages/manageEmployee/create"
import ManageIssue from "../pages/manageIssue"
import IssuesDetailesView from "../pages/manageIssue/detaileView"
import NotificationComponent from "../pages/notification"
import OtpScreen from "../pages/otpScreen"
import ProfileComponent from "../pages/profilePage"
import ResetPassword from "../pages/resetpassword"
import TraingingVideo from "../pages/traingingVideo"

export const PrivateRoutes = [
    {
        path: ROUTES.DASHBOARD,
        component: Dashboard,
    },
    {
        path: ROUTES.MANAGEEMPLOYEE,
        component: ManageEmployee,
    },
    {
        path: ROUTES.MANAGEEMPLOYEE_add,
        component: CreateEmployee,
    },
    {
        path: ROUTES.MANAGEEMPLOYEE_Edit,
        component: CreateEmployee,
    },
    {
        path: ROUTES.MANAGEDEPARTMENT,
        component: ManageDepartments,
    },
    {
        path: ROUTES.MANAGEDEPARTMENT_add,
        component: CreateDepartment,
    },
    {
        path: ROUTES.MANAGEDEPARTMENT_Edit,
        component: CreateDepartment,
    },
    {
        path: ROUTES.MANAGEISSUE,
        component: ManageIssue,
    },
    {
        path: ROUTES.MANAGEISSUE_View,
        component: IssuesDetailesView,
    },
    {
        path: ROUTES.MANAGEISSUE_DETAILE_VIEW,
        component: IssuesDetailesView,
    },
    {
        path: ROUTES.TRAINGING_VIDEO,
        component: TraingingVideo,
    },
    {
        path: ROUTES.NOTIFICATION,
        component: NotificationComponent,
    },
    {
        path: ROUTES.MANAGE_ADMIN,
        component: ManageAdminComponent,
    },
    {
        path: ROUTES.CREATE_ADMIN,
        component: CreateAdmin,
    },
    {
        path: ROUTES.PROFILE_PAGE,
        component: ProfileComponent,
    },

]

export const PublicRoutes = [
    {
        path: "*",
        component: Login
    },
    {
        path: ROUTES.FORGOTPASSWORD,
        component: ForgotPassword
    },
    {
        path: ROUTES.OTPSCREEN,
        component: OtpScreen
    },
    {
        path: ROUTES.RESETPASSWORD,
        component: ResetPassword
    },
]